import { gql } from "lib/apolloClient";

export const plannerElementNodeSetFragment = gql`
  fragment plannerElementNodeSetItem on PlannerElementNodeSet {
    id
    title
    isArchived
    standardSetWrapper {
      gradeScales {
        id
        type
        isArchived
        displayName
        templateName
      }
    }
  }
`;

export const plannerFragment = {
  plannerElementNodeFragment: gql`
    fragment plannerElementNodeItem on PlannerElementNode {
      id
      uid
      type
      label
      subText
      gradingType
      code
      depth
      displaySequence
      isLeaf
      children
      parent
      subType
      metadata
      updatedAt
      tags: genericTags {
        id
        label
        icon {
          id
          url
        }
      }
      parentData {
        id
        uid
      }
      standardsWrapper {
        standardSet {
          id
          type
          title
        }
        properties {
          isArchived
          isPowerStandard
          isGradedStandard
          subjects {
            id
            name
            isArchived
          }
          grades {
            id
            name
          }
          tags {
            id
            label
          }
        }
      }
      plannerElementNodeWrapper {
        properties {
          isGradedStandard
        }
      }
      dataSetNodeWrapper {
        properties {
          isGraded
          grades {
            id
            name
          }
          subjects {
            id
            name
            isArchived
          }
        }
      }

      standardCountWrapper {
        assignment {
          totalCount
        }
        assessment {
          totalCount
        }
        course {
          totalCount
        }
        portfolio {
          totalCount
        }
        unitPlan {
          totalCount
        }
      }
    }
  `,
  plannerBenchmark: gql`
    fragment plannerBenchmarkItem on PlannerBenchmark {
      id
      uid
      type
      label
      subText
      gradingType
      code
      depth
      parentData {
        id
        uid
      }
      benchmarkQuestionCount {
        count
      }
      standardsWrapper {
        standardSet {
          id
          type
          title
        }
        properties {
          isArchived
          isPowerStandard
          isGradedStandard
          grades {
            id
            name
          }
          tags {
            id
            label
          }
        }
      }
      subject
      levelId
      grades {
        id
        name
      }
      displaySequence
      children
      parent
      isLeaf
      tags {
        id
        label
        icon {
          id
          url
        }
      }
      dataSetNodeWrapper {
        properties {
          isGraded
        }
      }

      standardCountWrapper {
        assignment {
          totalCount
        }
        assessment {
          totalCount
        }
        course {
          totalCount
        }
        portfolio {
          totalCount
        }
        unitPlan {
          totalCount
        }
      }
    }
  `,
};

export const gradeScaleFragment = gql`
  fragment gradeScaleItem on GradeScaleConnection {
    edges {
      node {
        id
        displayName
        templateName
      }
    }
  }
`;
